// extracted by mini-css-extract-plugin
export default {"wrap":"Content_wrap__YWh6D","error":"Content_error__9Nxsq","alert":"Content_alert__9hY+b"};